import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'rds-loading-chart',
  templateUrl: './loading-chart.component.html',
  styleUrls: ['./loading-chart.component.scss']
})
export class LoadingChartComponent implements OnInit {

  //option: vertical_bar, horizontal_bar, pie, line
  @Input() chartType:string = "vertical_bar";

  lstThemePieCharts:any[] = [];
  themeBarV:any = {height: '50px', width: '250px'};
  themeBarH:any = {height: '100px', width: '50px'};

  constructor() { }

  ngOnInit() {
    setTimeout(() => {
      this.lstThemePieCharts.push();
    }, 3000);
  }

}
